import { ResponsiveBar } from '@nivo/bar';
import React from 'react';

import GraphTooltip from '~/views/dashboard/DashboardPage/components/AudiencesSection/components/GraphTooltip';

import { ChartTitle, ChartWrapper } from './AIInsightsUI.styles';
import { BarChartBlock } from './blockTypes';

interface Props {
  block: BarChartBlock;
}

const SimpleBarChart = ({ block }: Props) => {
  const data = block.data.map((d) => ({ label: d.label, value: d.value }));

  return (
    <div>
      <ChartTitle>{block.title}</ChartTitle>
      <ChartWrapper>
        <ResponsiveBar
          data={data}
          keys={['value']}
          indexBy="label"
          layout="horizontal"
          margin={{ top: 20, right: 30, bottom: 50, left: 110 }}
          axisBottom={{ legend: block.yLabel, legendPosition: 'middle', legendOffset: 36 }}
          axisLeft={{ legend: block.xLabel, legendPosition: 'middle', legendOffset: -100 }}
          animate={true}
          colors={['#f97316']}
          tooltip={(data) => <GraphTooltip dataKey={data.indexValue as string} count={data.value} />}
          theme={{
            axis: {
              ticks: { text: { fontSize: 11, fill: '#6b7280' } },
              legend: { text: { fontSize: 11, fill: '#6b7280' } },
            },
            grid: { line: { stroke: '#f3f4f6' } },
          }}
        />
      </ChartWrapper>
    </div>
  );
};

export default SimpleBarChart;
